import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { ImpersonationProvider } from "./contexts/ImpersonationContext";
import AdminImpersonationBanner from "./components/ui/AdminImpersonationBanner";

function App() {
  return (
    <AuthProvider>
      <ImpersonationProvider>
        <AdminImpersonationBanner />
        <Routes />
      </ImpersonationProvider>
    </AuthProvider>
  );
}

export default App;